// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"672":"4fad8c06","859":"95c88167"}[chunkId] + ".chunk.css";
};